import React, { Component } from 'react'
// import $ from 'jquery';
import firebase from './firebase'
import { update_user, remove_user, onOpen } from '../store/actions/actions';
import { connect } from 'react-redux';
import { withRouter, } from 'react-router-dom'
import '../screens/Admin/styles.css'
import { Redirect } from 'react-router-dom'



class NavBarAdmin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            displayEmail: '',
            dawOpem: false,
            user: this.props.user.user.uid
        };
        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }
    componentDidMount() {
        this.authListener();

    }

    authListener() {
        firebase.auth().onAuthStateChanged(user => {
            if (user) {
                // console.log("user changed..", user.email);
                this.setState({
                    // uid: user.uid,
                    displayEmail: user.email
                });
            } else {
                // No user is signed in.
                // browserHistory.push("/signin");
            }
        });
    }


    logout = () => {
        const { history } = this.props;
        firebase.auth().signOut()
            .then(() => {
                history.push("/Login");
                // Sign-out successful.
            }).catch(function (error) {
                // An error happened.
                console.log(error.message)
            });
        this.props.logout_user()
    }




    onDraw = () => {
        // console.log('asd')
        const { dawOpem } = this.state
        this.setState({ dawOpem: !this.state.dawOpem });
        this.props.onToggle(dawOpem)
    }
    render() {
        // const { displayEmail } = this.state;
        const { user } = this.props

        if (user === null)
            return <Redirect to="/login" />
        return (
            <div>
                <nav class="sb-topnav navbar navbar-expand navbar-dark bg-dark">
                    <a class="navbar-brand" href="index.html">Adnan Ahmed | Admin</a>
                    <button class="btn btn-link btn-sm order-1 order-lg-0" id="sidebarToggle" onClick={() => this.onDraw()}><i class="fas fa-bars" ></i></button>

                    <ul class="nav navbar-nav ml-auto">
                        <li class="nav-item dropdown">
                            <span class="nav-link dropdown-toggle" id="userDropdown" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fas fa-user fa-fw"></i></span>
                            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="userDropdown">
                                <span class="dropdown-item" href="#" style={{ textDecoration: 'none', cursor: 'pointer' }}>Settings</span>
                                <span class="dropdown-item" style={{ textDecoration: 'none', cursor: 'pointer' }} >Activity Log</span>
                                <div class="dropdown-divider"></div>
                                <span class="dropdown-item" style={{ textDecoration: 'none', cursor: 'pointer' }} onClick={this.logout}>Logout</span>
                            </div>
                        </li>
                    </ul>
                </nav>
            </div>
        )
    }

}
const mapStateToProps = state => {
    return {
        user: state.user,

    }
}


const mapDispatchToProps = dispatch => {
    return {
        store_user: (user) => dispatch(update_user(user)),
        logout_user: () => dispatch(remove_user()),
        onToggle: (user) => dispatch(onOpen(user)),
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NavBarAdmin));